import React, { useState } from 'react';
import styles from './Input.module.scss';
import clsx from 'clsx';
import { Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
const Input = ({ showError = true, list = [], type, className, form, name, placeholder, label, rules = { required: { value: true, message: 'Обязательно поле' } }, suffix, prefix, disabled }) => {
  const error = form.formState?.errors?.[name]?.message;
  const value = form.watch(name);
  const [showOptions, setShowOptions] = useState(false);
  const selectValue = list?.find((item) => item?.value == value);
  return (
    <>
      <div className={clsx(styles.wrap, className, type == 'select' && styles.wrapSelect, disabled && styles.wrapDisabled)}>
        {error && showError && <div className={clsx(styles.error, error && styles.errorShow)}>{error}</div>}
        {type == 'select' ? (
          <div className={styles.selectWrap}>
            <input
              placeholder={placeholder}
              type="text"
              className={clsx(styles.input, error && styles.inputError, styles.select)}
              autoComplete="off"
              onChange={() => {}}
              onFocus={() => {
                setShowOptions(true);
              }}
              onBlur={() => {
                setShowOptions(false);
              }}
            />
            <div className={clsx(styles.selectArrow, showOptions && styles.selectArrowActive)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            {selectValue && (
              <div className={clsx(styles.option, styles.optionSelected)}>
                {selectValue?.image && <img src={selectValue?.image} className={clsx(styles.optionImg)} width="40px" height={'40px'} />}
                <span className={clsx(styles.optionLabel)}>{selectValue?.label}</span>
              </div>
            )}
            <div className={clsx(styles.dropdown, showOptions && styles.dropdownOpen)}>
              {list
                ?.filter((item) => item?.value)
                ?.map((item) => (
                  <div
                    key={item?.value}
                    className={clsx(styles.option, selectValue?.value == item?.value && styles.optionActive)}
                    onClick={() => {
                      form.setValue(name, item?.value, { shouldValidate: true });
                    }}>
                    {item?.image && <img src={item?.image} className={clsx(styles.optionImg)} />}
                    <span className={clsx(styles.optionLabel)}>{item?.label}</span>
                  </div>
                ))}
            </div>
            <select {...form?.register(name, rules)} style={{ display: 'none' }}>
              {list?.map((item) => (
                <option value={item?.value}>{item?.label}</option>
              ))}
            </select>
          </div>
        ) : type == 'number' ? (
          <Controller
            control={form.control}
            name={name}
            rules={rules}
            render={({ field: { onChange, name, value } }) => (
              <>
                <NumericFormat suffix={suffix} prefix={prefix} placeholder={placeholder} className={clsx(styles.input, error && styles.inputError, value && styles.inputFill)} thousandSeparator=" " name={name} value={value} onValueChange={(val) => onChange(val.floatValue)} autoComplete="off" />
              </>
            )}
          />
        ) : (
          <input disabled={disabled} placeholder={placeholder} type="text" className={clsx(styles.input, error && styles.inputError, value && styles.inputFill)} {...form?.register(name, rules)} autoComplete="off" />
        )}

        <span className={clsx(styles.label, value && styles.labelUp)}>{label}</span>
      </div>
    </>
  );
};

export default Input;
